import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgThumbsUp: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 335.62 366.17" {...props}>
    <path
      d="M263.96 73.52a148.94 148.94 0 0 1-6.83-14.69L242.7 21.3a7.13 7.13 0 0 0-10.2-3.77l-12.53 6.61c-4.05 2.11-10.69 2.58-14.95 1.2 0 0-32.02-10.68-54.17-9.74-23.66 1.07-56.63 17.07-56.63 17.07-4.03 1.95-10.81 2.23-15.06.7l-12.89-4.61a7.07 7.07 0 0 0-9.55 5.18l-8.68 36.88A137.37 137.37 0 0 1 43.1 86.3s-14.59 35.46-13.45 59.95c3.35 68.68 63 121.56 133.33 118.25 70.16-3.33 124.53-61.8 121.18-130.49-1.15-25.63-20.2-60.48-20.2-60.48z"
      fill="#ff841f"
    />
    <circle cx={210.35} cy={112.92} r={41.33} opacity={0.1} />
    <circle cx={207.57} cy={117.09} r={41.33} fill="#fff" />
    <circle cx={115.42} cy={124.84} r={41.33} opacity={0.1} />
    <circle cx={112.64} cy={129.57} r={41.33} fill="#fff" />
    <path
      d="M206.9 123.83a10.1 10.1 0 0 1-9.46 10.63 10.1 10.1 0 0 1-10.63-9.47c-.34-5.52 3.94-10.3 9.46-10.63s10.3 3.95 10.63 9.47z"
      fill="#191919"
    />
    <path
      d="M243.66 356.1c0-6.88-31.91-13.25-71.28-13.25s-71.27 5.27-71.27 12.14c0 6.88 31.9 9.65 71.27 9.65s71.28-1.67 71.28-8.55z"
      opacity={0.28}
    />
    <path
      d="M183.35 164.33s-8.27 6.06-8.48 26.49l-9.93-.78-22.01-21.47 40.42-4.24z"
      fill="#fff"
    />
    <path
      d="M177.62 166.33s-6.1 3.36-6.3 23.78l-10.19.07-23.86-21.62 40.35-2.23z"
      fill="#353333"
    />
    <path
      d="M151.3 180.06c-.48-1.08 10.2-3.44 12.73 3.55 0 0 .66-2.4-1.07-4.1 0 0 4.01-.78 7.86 6.49 0 0 1.3 3.35-.3 3.7 0 0-12.76 4.71-19.22-9.64z"
      fill="#f27314"
    />
    <path
      d="M137.27 168.56s13.72-9.15 24.12-23.2c0 0 21.2 11.54 31.82 13.25 0 0-3.8 4.5-19.6 8.9 0 .01-26.2 5.1-36.34 1.05zm.02.04s18.53 24.42 18.11 26.72c0 0 4.63 3.17 24.33-5.04l-20.36-.96s-.03-9.97-22.08-20.72z"
      fill="#fff"
    />
    <path
      d="M142.77 133.07a2.02 2.02 0 0 0 .1-3.73c-16.14-7.14-32.49-2.42-33.18-2.21a2.02 2.02 0 0 0 1.15 3.87 51 51 0 0 1 23.5-.28c-6.54 1.6-15.97 4.53-21.96 9.13a2.02 2.02 0 0 0 2.46 3.2c8.93-6.86 27.33-9.84 27.52-9.87.14-.02.28-.06.41-.11z"
      fill="#191919"
    />
    <path
      d="M308.97 111.08s7.5-19.67-4.3-26.06c-7.3-3.96-10.78 6.37-11.86 11.2-.9 4.09-5.17 13.16-6.46 15.85-5.59 6.24-10.44 8.67-11.49 11.96l-10.09 42.77c38.68 2.52 53.8-26.9 53.8-26.9 6.56-14.61.79-25.51-9.6-28.83z"
      fill="#ff841f"
    />
    <path
      d="M51.05 132.12s-47 61.79-24.97 87.99c0 0 12.5 2.36 13-11.5 0 0 14.53-.24 12.12-13.35 0 0 14.1-1.32 13.45-12.14 0 0-8.84-25.84-8.12-34.03 0 0 .89-19.63-5.48-16.97z"
      fill="#fd8431"
    />
  </svg>
);
/* eslint-enable max-len */

export default SvgThumbsUp;
